
import React from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Download, Eye, CheckCircle2 } from 'lucide-react';
import { Contract } from './types';

interface ContractTemplatesProps {
  templates: Contract[];
  onPreview: (contract: Contract) => void;
  onDownload: (contract: Contract) => void;
}

const ContractTemplates: React.FC<ContractTemplatesProps> = ({ 
  templates, 
  onPreview, 
  onDownload 
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {templates.map((template) => (
        <Card key={template.id} className="transition-all hover:shadow-md">
          <CardHeader>
            <div className="flex justify-between items-start">
              <CardTitle>{template.title}</CardTitle>
              <Badge variant={template.premium ? "default" : "outline"}>
                {template.premium ? "Premium" : "Free"}
              </Badge>
            </div>
            <CardDescription>{template.description}</CardDescription>
          </CardHeader>
          <CardContent>
            <div className="text-sm text-muted-foreground mb-4">
              <span className="flex items-center gap-2 mb-1">
                <CheckCircle2 className="h-4 w-4 text-green-500" />
                <span>Last updated: {template.lastUpdated}</span>
              </span>
              <span className="flex items-center gap-2">
                <CheckCircle2 className="h-4 w-4 text-green-500" />
                <span>Compatible with {template.compatibleWith}</span>
              </span>
            </div>
          </CardContent>
          <CardFooter className="flex justify-between">
            <Button 
              variant="outline" 
              size="sm" 
              className="gap-2"
              onClick={() => onPreview(template)}
            >
              <Eye className="h-4 w-4" />
              <span>Preview</span>
            </Button>
            <Button 
              className="gap-2" 
              size="sm" 
              onClick={() => onDownload(template)}
            >
              <Download className="h-4 w-4" />
              <span>Download</span>
            </Button>
          </CardFooter>
        </Card>
      ))}
    </div>
  );
};

export default ContractTemplates;
